import React, { useEffect, useState } from 'react';
import styles from './ReadingTargets.module.scss';
import cx from 'classnames';

import { getFlagColor } from '../../../../utils/constants';
import Boomer from '../../../../images/loader-boomer.png';
import { Flag } from 'react-feather';

import iconTeacher from '../../images/icon_teacher.png';
import iconParent from '../../images/icon_home_black.png';
import iconBoomer from '../../../../images/boomer-icon.png';

import { Button } from '@squirrellearningltd/go-teacher-components';
import { useMutation } from '@apollo/react-hooks';
import { CREATE_STUDENT_WEEKLY_TARGET } from '../../services/graphql';
import ReadingTarget from '../../../Shared/ReadingTarget';
import { FormErrors } from '@squirrellearningltd/go-teacher-components';
import moment from 'moment';
import { GET_CLASS_STUDENTS_FOR_READING_TARGET } from '../../services/graphql';

import { Link, Location } from '@reach/router';

const ReadingTargets = ({
    students,
    selectedStudents,
    onSelectStudent,
    viewReadingTargets,
    weekStart,
    id,
    currentWeekSelected
}) => {
    const [teacherLogsDisabled, setTeacherLogsDisabled] = useState(true);
    const [parentLogsDisabled, setParentLogsDisabled] = useState(true);
    const [boomerLogsDisabled, setBoomerLogsDisabled] = useState(true);
    const [teacherLogsChecked, setTeacherLogsChecked] = useState(true);
    const [parentLogsChecked, setParentLogsChecked] = useState(true);
    const [boomerLogsChecked, setBoomerLogsChecked] = useState(true);

    const [teacherLogs, setTeacherLogs] = useState(0);
    const [parentLogs, setParentLogs] = useState(0);
    const [boomerLogs, setBoomerLogs] = useState(0);

    const [teacherFormError, setTeacherFormError] = useState(false);
    const [parentFormError, setparentFormError] = useState(false);
    const [boomerFormError, setBoomerFormError] = useState(false);

    const [readingTargetErrors, setReadingTargetErrors] = useState([]);

    const [touched, setTouched] = useState(false);

    useEffect(() => {
        if (!selectedStudents.length) {
            setTeacherFormError(false);
            setparentFormError(false);
            setBoomerFormError(false);

            setTeacherLogsDisabled(true);
            setParentLogsDisabled(true);
            setBoomerLogsDisabled(true);

            setTeacherLogsChecked(false);
            setParentLogsChecked(false);
            setBoomerLogsChecked(false);

            setTeacherLogs(0);
            setParentLogs(0);
            setBoomerLogs(0);
        }
    }, [selectedStudents]);

    useEffect(() => {
        if (!teacherLogsChecked) {
            // Reset value to 0 when unchecked
            setTeacherLogs(0);
        }

        if (!parentLogsChecked) {
            // Reset value to 0 when unchecked
            setParentLogs(0);
        }

        if (!boomerLogsChecked) {
            // Reset value to 0 when unchecked
            setBoomerLogs(0);
        }

        if (!teacherLogsChecked && !parentLogsChecked && !boomerLogsChecked) {
            // Disable submit button when all unchecked
            setTouched(false);
            setTeacherLogsDisabled(true);
            setParentLogsDisabled(true);
            setBoomerLogsDisabled(true);
        }
    }, [teacherLogsChecked, parentLogsChecked, boomerLogsChecked]);

    const [setTarget] = useMutation(CREATE_STUDENT_WEEKLY_TARGET, {
        onCompleted: () => {
            setTeacherLogsChecked(false);
            setParentLogsChecked(false);
            setBoomerLogsChecked(false);

            setReadingTargetErrors([]);
        },
        onError: (data) =>
            setReadingTargetErrors(data.createStudentWeeklyTargets.errors),
        awaitRefetchQueries: true,
        refetchQueries: () => [
            {
                query: GET_CLASS_STUDENTS_FOR_READING_TARGET,
                variables: {
                    id,
                    weekStart: moment(weekStart).format('DD/MM/YYYY'),
                },
            },
        ],
    });

    return (
        <div className={styles.ReadingTargetsPageContainer}>
            <div className={styles.StudentsList}>
                {students.map((student) => (
                    <div key={student.id} className={styles.row}>
                        <Location>
                            {() => (
                                <div className={styles.rowMain}>
                                    <div
                                        className={cx(
                                            'basic-form__group--check',
                                            styles.rowStCheck
                                        )}
                                    >
                                        <input
                                            name='student'
                                            className='basic-form__check-box'
                                            type='checkbox'
                                            value={student.id}
                                            onChange={(e) => onSelectStudent(e)}
                                            checked={
                                                selectedStudents.indexOf(
                                                    student.id
                                                ) > -1
                                            }
                                            id={`st_${student.id}`}
                                        />
                                        <label
                                            className='basic-form__check-label'
                                            htmlFor={`st_${student.id}`}
                                        >
                                            &nbsp;
                                        </label>
                                    </div>

                                    <Link
                                        to={`/student/${student.id}`}
                                        className={styles.studentInfoWrapper}
                                    >
                                        <div className={styles.studentInfo}>
                                            <div className={styles.rowBoomer}>
                                                <img
                                                    src={
                                                        student.boomerAvatarUrl
                                                            ? `${
                                                                  student.boomerAvatarUrl
                                                              }?v=${student.updatedAt.replace(
                                                                  /\s/g,
                                                                  ''
                                                              )}`
                                                            : Boomer
                                                    }
                                                    className={styles.boomerImg}
                                                />
                                                {student.flagType && (
                                                    <span
                                                        style={{
                                                            background:
                                                                getFlagColor(
                                                                    student.flagType
                                                                ),
                                                        }}
                                                        className={
                                                            styles.rowFlag
                                                        }
                                                    >
                                                        <Flag
                                                            fill='#fff'
                                                            color='#fff'
                                                            size='14'
                                                        />
                                                    </span>
                                                )}
                                            </div>

                                            <div className={styles.rowInfo}>
                                                <p>{student.name}</p>
                                            </div>
                                        </div>

                                        <div className={styles.readingLogs}>
                                            <ReadingTarget
                                                weekStart={weekStart}
                                                student={student}
                                                viewReadingTargets={
                                                    viewReadingTargets
                                                }
                                                currentWeekSelected={currentWeekSelected}
                                            ></ReadingTarget>
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </Location>
                    </div>
                ))}
            </div>

            <div className={styles.WeeklyTarget}>
                <h2 className={styles.WeeklyTargetTitle}>
                    Set a weekly target
                </h2>
                <div className={styles.WeeklyTargetValue}>
                    <div className='u-display-flex u-align-center'>
                        <img src={iconTeacher} width={28} alt='Teacher reads' />

                        <div className={styles.checkboxLabel}>
                            Teacher log target
                        </div>

                        <div className='basic-form__group--check'>
                            <input
                                name='teacherTarget'
                                className='basic-form__check-box'
                                type='checkbox'
                                checked={teacherLogsChecked}
                                disabled={!selectedStudents.length}
                                onChange={() => {
                                    setTeacherLogsChecked(!teacherLogsChecked);
                                    setTeacherLogsDisabled(
                                        !teacherLogsDisabled
                                    );
                                }}
                                id='teacherTarget'
                            />
                            <label
                                className={`basic-form__check-label ${
                                    !selectedStudents.length ? 'disabled' : ''
                                }`}
                                htmlFor='teacherTarget'
                            >
                                &nbsp;
                            </label>
                        </div>
                    </div>

                    <div>
                        <input
                            type='number'
                            inputMode='numeric'
                            className={cx('u-m-right-10', styles.styledInput)}
                            value={teacherLogs}
                            onChange={(e) => {
                                if (!touched) {
                                    setTouched(true);
                                }
                                if (
                                    e.currentTarget.value &&
                                    e.currentTarget.value >= 0 &&
                                    e.currentTarget.value <= 100
                                ) {
                                    setTeacherFormError(false);
                                } else {
                                    setTeacherFormError(true);
                                }
                                setTeacherLogs(e.currentTarget.value);
                            }}
                            disabled={teacherLogsDisabled}
                            step='1'
                            min='0'
                            max='100'
                        />
                    </div>
                </div>
                <div className={styles.WeeklyTargetValue}>
                    <div className='u-display-flex u-align-center'>
                        <img src={iconParent} width={28} alt='Parent reads' />

                        <div className={styles.checkboxLabel}>
                            Parent log target
                        </div>

                        <div className='basic-form__group--check'>
                            <input
                                name='parentTarget'
                                className='basic-form__check-box'
                                type='checkbox'
                                checked={parentLogsChecked}
                                disabled={!selectedStudents.length}
                                onChange={() => {
                                    setParentLogsChecked(!parentLogsChecked);
                                    setParentLogsDisabled(!parentLogsDisabled);
                                }}
                                id='parentTarget'
                            />
                            <label
                                className={`basic-form__check-label ${
                                    !selectedStudents.length ? 'disabled' : ''
                                }`}
                                htmlFor='parentTarget'
                            >
                                &nbsp;
                            </label>
                        </div>
                    </div>

                    <div>
                        <input
                            type='number'
                            inputMode='numeric'
                            className={cx('u-m-right-10', styles.styledInput)}
                            value={parentLogs}
                            onChange={(e) => {
                                if (!touched) {
                                    setTouched(true);
                                }
                                if (
                                    e.currentTarget.value &&
                                    e.currentTarget.value >= 0 &&
                                    e.currentTarget.value <= 100
                                ) {
                                    setparentFormError(false);
                                } else {
                                    setparentFormError(true);
                                }
                                setParentLogs(e.currentTarget.value);
                            }}
                            disabled={parentLogsDisabled}
                            step='1'
                            min='0'
                            max='100'
                        />
                    </div>
                </div>
                <div className={styles.WeeklyTargetValue}>
                    <div className='u-display-flex u-align-center'>
                        <img src={iconBoomer} width={28} alt='Boomer reads' />

                        <div className={styles.checkboxLabel}>
                            Student log target
                        </div>

                        <div className='basic-form__group--check'>
                            <input
                                name='boomerTarget'
                                className='basic-form__check-box'
                                type='checkbox'
                                checked={boomerLogsChecked}
                                disabled={!selectedStudents.length}
                                onChange={() => {
                                    setBoomerLogsChecked(!boomerLogsChecked);
                                    setBoomerLogsDisabled(!boomerLogsDisabled);
                                }}
                                id='boomerTarget'
                            />
                            <label
                                className={`basic-form__check-label ${
                                    !selectedStudents.length ? 'disabled' : ''
                                }`}
                                htmlFor='boomerTarget'
                            >
                                &nbsp;
                            </label>
                        </div>
                    </div>

                    <div>
                        <input
                            type='number'
                            inputMode='numeric'
                            className={cx('u-m-right-10', styles.styledInput)}
                            value={boomerLogs}
                            onChange={(e) => {
                                if (!touched) {
                                    setTouched(true);
                                }
                                if (
                                    e.currentTarget.value &&
                                    e.currentTarget.value >= 0 &&
                                    e.currentTarget.value <= 100
                                ) {
                                    setBoomerFormError(false);
                                } else {
                                    setBoomerFormError(true);
                                }
                                setBoomerLogs(e.currentTarget.value);
                            }}
                            disabled={boomerLogsDisabled}
                            step='1'
                            min='0'
                            max='100'
                        />
                    </div>
                </div>

                <Button
                    className='u-m-top-2 u-m-right-1'
                    disabled={
                        !selectedStudents.length ||
                        !touched ||
                        (touched &&
                            (teacherFormError ||
                                parentFormError ||
                                boomerFormError))
                    }
                    onClick={() =>
                        setTarget({
                            variables: {
                                studentIds: selectedStudents,
                                teacherLogsTarget: teacherLogsChecked && +teacherLogs >= 0
                                    ? +teacherLogs
                                    : null,
                                parentLogsTarget: parentLogsChecked && +parentLogs >= 0
                                    ? +parentLogs
                                    : null,
                                studentLogsTarget: boomerLogsChecked && +boomerLogs >= 0
                                    ? +boomerLogs
                                    : null,
                            },
                        })
                    }
                >
                    Set Target
                </Button>

                {teacherFormError && (
                    <FormErrors
                        errors={[
                            'Teacher Log target Invalid. Please add a value between 0 and 100.',
                        ]}
                    />
                )}
                {parentFormError && (
                    <FormErrors
                        errors={[
                            'Parent Log target Invalid. Please add a value between 0 and 100.',
                        ]}
                    />
                )}
                {boomerFormError && (
                    <FormErrors
                        errors={[
                            'Student Log target Invalid. Please add a value between 0 and 100.',
                        ]}
                    />
                )}

                {selectedStudents.length >= 2 && touched && (
                    <FormErrors
                        errors={['This will overwrite any existing targets ']}
                    />
                )}
                <FormErrors
                    errors={
                        readingTargetErrors.length ? readingTargetErrors : []
                    }
                />
            </div>
        </div>
    );
};

export default ReadingTargets;
